var FcRequestersInputModule = /** @class */ (function () {
    function FcRequestersInputModule() {
    }
    return FcRequestersInputModule;
}());
export { FcRequestersInputModule };
